import { FC, PropsWithChildren } from "react";
import { AccordionItemContextProvider } from "../../providers/AccordionItemProvider";
import styles from "./AccordionItem.module.scss";
export const AccordionItem: FC<PropsWithChildren> = ({ children }) => {
	return (
		<AccordionItemContextProvider>
			<div className={styles.item}>{children}</div>
		</AccordionItemContextProvider>
	);
};
